import { render, staticRenderFns } from "./Connectwallet.vue?vue&type=template&id=66c1db2a&scoped=true&"
import script from "./Connectwallet.vue?vue&type=script&lang=js&"
export * from "./Connectwallet.vue?vue&type=script&lang=js&"
import style0 from "./Connectwallet.vue?vue&type=style&index=0&id=66c1db2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1db2a",
  null
  
)

export default component.exports